// extracted by mini-css-extract-plugin
export var blockTitle = "cost-module--block-title--2965a";
export var btnBlock = "cost-module--btn-block--7995d";
export var checkList = "cost-module--check-list--dc53a";
export var col = "cost-module--col--ca623";
export var cost = "cost-module--cost--02dd5";
export var costUndertext = "cost-module--cost-undertext--7c498";
export var mainCost = "cost-module--main-cost--2a7af";
export var pack = "cost-module--pack--0627a";